import { render, staticRenderFns } from "./linkTemplateModal.vue?vue&type=template&id=5474d28a&"
import script from "./linkTemplateModal.vue?vue&type=script&lang=js&"
export * from "./linkTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports